import { cn } from "../../../utils";

type TPaginationLoaderProps = {
  className?: string;
};

export default function PaginationLoader({
  className,
}: TPaginationLoaderProps) {
  return (
    <div
      className={cn(
        "flex items-center justify-between w-full mt-4 animate-pulse",
        className,
      )}
      data-testid="pagination-loader"
    >
      {/* Left side: "Show" label + dropdown skeleton */}
      <div data-testid="pagination-left" className="flex items-center gap-2">
        <div
          data-testid="skeleton-block"
          className="h-6 w-10 bg-gray-300 rounded"
        ></div>
        <div
          data-testid="skeleton-block"
          className="h-8 w-16 bg-gray-300 rounded"
        ></div>
      </div>

      {/* Right side: pagination buttons skeleton */}
      <div data-testid="pagination-right" className="flex items-center gap-2">
        <div
          data-testid="skeleton-block"
          className="h-8 w-8 rounded bg-gray-300"
        ></div>
        <div
          data-testid="skeleton-block"
          className="h-8 w-8 rounded bg-gray-300"
        ></div>
        <div
          data-testid="skeleton-block"
          className="h-8 w-8 rounded bg-gray-300"
        ></div>
      </div>
    </div>
  );
}
